export default __webpack_public_path__ + "static/media/DwaralkaTirumala.6ae0c508.webp";